import { render, staticRenderFns } from "./pdetailImgs.vue?vue&type=template&id=5662c221&scoped=true&"
import script from "./pdetailImgs.vue?vue&type=script&lang=js&"
export * from "./pdetailImgs.vue?vue&type=script&lang=js&"
import style0 from "./pdetailImgs.vue?vue&type=style&index=0&id=5662c221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662c221",
  null
  
)

export default component.exports